import React, { useState, useEffect } from 'react';
import { Route, Switch } from "react-router-dom";
import '../common/css/global.css';
import './App.css';
import * as impact from '../common/api/impact';
import LandingPage from "./pages/LandingPage";
import ImpactPage from "./pages/ImpactPage";
function App() {
  const merchantCode = 'BES_AU_STRATEGIC_CONSULTING_PARTNERSHIPS';
  const [fetchedImpact, setFetchedImpact] = useState();
useEffect(() => {
    impact.merchants(merchantCode)
      .then(response => response.json())
      .then(body => {
        setFetchedImpact(body)
      })
      .catch(error => {
        console.error(error);
        setFetchedImpact(error)
      })
  }, []);
  return (
    <>
      <Switch>
        {/* DO NOT DELETE IMPACT - The impact page should always be kept, even if not specified in a design */}
        <Route
          exact
          path={`/impact`}
          key="app-scp-impact"
        >
          <ImpactPage merchantCode={merchantCode} />
        </Route>
        {/* DO NOT DELETE IMPACT - The impact page should always be kept, even if not specified in a design */}
        <Route
          path={`/`}
          key="app-scp-landing"
        >
          <LandingPage  fetchedImpact={fetchedImpact} merchantCode={merchantCode} />
        </Route>
      </Switch>
    </>
  );
}
export default App;
